export enum AIChatType {
  PATIENT_QA = "PATIENT_QA",
}
